module.exports = __webpack_public_path__ + "img/goal_wealth.d75361d2.png";